module.exports = __webpack_public_path__ + "img/add-event-cover.d7748157.svg";